
import { EAuthMethod, EOneTimeLinkSentStatus } from '@/helpers/enums'
import { validateEnum } from '@/helpers/index'

export default {
  name: 'LoginOneTimeLinkNotification',
  props: {
    status: {
      type: String,
      validator(value) {
        return validateEnum(value, EOneTimeLinkSentStatus)
      },
      default: EOneTimeLinkSentStatus.NOT_TRIGERRED
    }
  },
  data() {
    return {
      method: EAuthMethod.ONE_TIME_LINK
    }
  },
  computed: {
    isExpired() {
      return this.status === EOneTimeLinkSentStatus.EXPIRED
    },
    isSent() {
      return this.status === EOneTimeLinkSentStatus.SENT
    },
    isInvalid() {
      return this.status === EOneTimeLinkSentStatus.INVALID
    },
    showButton() {
      const statuses = [EOneTimeLinkSentStatus.INVALID, EOneTimeLinkSentStatus.EXPIRED]
      return statuses.includes(this.status)
    },
    showCard() {
      const statuses = [
        EOneTimeLinkSentStatus.INVALID,
        EOneTimeLinkSentStatus.EXPIRED,
        EOneTimeLinkSentStatus.SENT
      ]
      return statuses.includes(this.status)
    },
    cardText() {
      if (this.isSent) {
        return {
          title: this.$t('talent.login.one.time.check.your.email'),
          text: ''
        }
      } else if (this.isExpired) {
        return {
          title: this.$t('talent.login.one.time.link.expired.title'),
          text: this.$t('talent.login.one.time.link.expired')
        }
      } else if (this.isInvalid) {
        return {
          title: this.$t('talent.login.one.time.link.invalid.title'),
          text: this.$t('talent.login.one.time.link.invalid')
        }
      } else {
        return { title: '', text: '' }
      }
    },
    cardButton() {
      if (this.isExpired) {
        return {
          buttonText: this.$t('talent.login.button.new.one.time.link'),
          buttonId: 'requestNewOtlLink'
        }
      } else if (this.isInvalid) {
        return {
          buttonText: this.$t('talent.login.one.time.link.go.back'),
          buttonId: 'goBackToLogin'
        }
      } else {
        return { buttonText: '', buttonId: '' }
      }
    },
    cardIcon() {
      if (this.isSent) {
        return {
          src: require('@/assets/svg/mailbox.svg'),
          alt: this.$t('talent.login.one.time.link.mailbox.icon')
        }
      } else if (this.isExpired) {
        return {
          src: require('@/assets/svg/hourglass.svg'),
          alt: this.$t('talent.login.one.time.link.hourglass.icon')
        }
      } else if (this.isInvalid) {
        return {
          src: require('@/assets/svg/error.svg'),
          alt: this.$t('talent.login.one.time.link.error.icon')
        }
      } else {
        return { src: '', alt: '' }
      }
    }
  },
  methods: {
    handleButtonClick() {
      this.$router.push(this.$link.login())
      this.$emit('select:method', this.method)
    }
  }
}
